import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog'
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from 'react-router-dom';
import {FormattedMessage} from "react-intl";

/*
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
*/

const AfterDraftSave = (props) => {
    const history = useHistory();

    return (
        <Dialog
            open={props?.open}
            onClose={() => props.setOpen(false)}
            role="alertdialog"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <FormattedMessage id="draft.dialog.title" />
            </DialogTitle>
            <DialogContent id="alert-dialog-description">
                <FormattedMessage id="draft.dialog.description" values={{title: props.title}} />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={() => props.setOpen(false)}>
                    <FormattedMessage id={'continue.filling'} />
                </Button>
                <Button className={"afterDraftSaveButton"} variant="contained" color="primary" onClick={() => history.push(`/questionnaires/`)}>
                    <FormattedMessage id={'navigate.to.questionnaires'} />
                </Button>
            </DialogActions>
        </Dialog>
    )

    /*
    return (
        <div>
            <Modal
                open={props?.open}
                onClose={() => props.setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className={'formula-modal-title'}>
                    <Typography id="modal-modal-title" variant="h4" component="h4">
                        {props.title}
                    </Typography>
                    </div>
                    <div className={'formula-modal-title'}>
                    <Typography id="modal-modal-title" component="span">
                        Antamasi kyselyvastaukset on tallennettu. Kyselyyn vastaaminen on vielä kesken. Voit palata kyselyt sivulle tai jatkaa täyttämistä.
                    </Typography>
                    </div>
                    <Button variant="contained" color="primary" onClick={() => history.push(`/questionnaires/`)}>
                        <FormattedMessage id={'navigate.to.questionnaires'} />
                    </Button>
                    <Button variant="outlined" color="primary" onClick={() => props.setOpen(false)}>
                        <FormattedMessage id={'continue.filling'} />
                    </Button>
                </Box>
            </Modal>
        </div>
    );*/
}

export default AfterDraftSave;